module.exports = __webpack_public_path__ + "7bb19efb.webp";